import { render, staticRenderFns } from "./SuratPernyataanNonPKP.vue?vue&type=template&id=3efc68b8&"
import script from "./SuratPernyataanNonPKP.vue?vue&type=script&lang=js&"
export * from "./SuratPernyataanNonPKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports